<div class="staff-menu ag-pa-md">
  <h4 class="text-center">
    Staff Menu
    <i
      class="fa fa-times pull-right close-sidenav"
      aria-hidden="true"
      title="Close Staff Menu"
      (click)="closeNav()"
    ></i>
  </h4>
  <div *ngIf="staffMenuItems" style="padding-top: 5px; padding-bottom: 5px">
    <div style="width: inherit; padding: 0; margin: 0">
      <div *ngFor="let sMenus of staffMenuItems">
        <div class="staff-list">
          <div class="header-title" tabindex="0" (agInteract)="toggleMenu(sMenus)">
            {{ sMenus?.label }}
            <span class="header-icon">
              <i
                [ngClass]="sMenus.expanded ? 'fa-angle-down' : 'fa-angle-right'"
                class="fa"
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <div *ngIf="sMenus.expanded" class="collapsable">
            <ul *ngFor="let sLinks of sMenus.items">
              <li class="main-items" [ngClass]="sLinks.url ? 'main-link' : 'no-link'">
                <a
                  *ngIf="sLinks.url; else noLink"
                  tabindex="0"
                  (agInteract)="openStaffIframe(sLinks.menuItem)"
                >
                  {{ sLinks.label }}
                </a>
                <ng-template #noLink>
                  <span>
                    {{ sLinks.label }}
                  </span>
                </ng-template>
                <ul *ngFor="let subitems of sLinks.subItems">
                  <li class="sub-items">
                    <a tabindex="0" (agInteract)="openStaffIframe(subitems.menuItem)">
                      {{ subitems.label }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
